import { h, FunctionalComponent } from "@stencil/core"

export type StzhInputDescriptionProps = {
  id: string
  classPrefix: string
  error?: string[]
  description?: string
  descriptionLong?: string
  descriptionLongTitle?: string,
  descriptionLongUsed?: boolean,
  moreInfoButtonLabel?: string
}

export const StzhInputDescription: FunctionalComponent<StzhInputDescriptionProps> = ({
  id,
  classPrefix,
  error,
  description,
  descriptionLong,
  descriptionLongTitle,
  descriptionLongUsed,
  moreInfoButtonLabel
}) => {
  return (
    <div
      class={`${classPrefix}__description-wrapper`}
      id={id}
    >
      <div class={`${classPrefix}__error`}>
        {error.length > 0 ?
          <ul class={`${classPrefix}__error-list`}>
            {error.map((error) =>
              <li class={`${classPrefix}__error-listitem`}>{error}</li>
            )}
          </ul>
          :
          <slot name="error"></slot>
        }
      </div>
      <div class={`${classPrefix}__description`}>
        {descriptionLongUsed &&
          <div class={`${classPrefix}__description-long`}>
            <stzh-popover
              class={`${classPrefix}__description-long-popover`}
              variant="tooltip"
            >
              <button
                class={`${classPrefix}__description-long-button`}
                aria-label={moreInfoButtonLabel}
                type="button"
                s-object-id={moreInfoButtonLabel}
              >
                <stzh-icon
                  class={`${classPrefix}__description-long-icon`}
                  name="info-help"
                ></stzh-icon>
              </button>
              <div slot="label">
                {descriptionLongTitle || description ? descriptionLongTitle || description : <slot name="description-long-title"></slot>}
              </div>
              <stzh-text curve="none" slot="content">
                {descriptionLong ? descriptionLong : <slot name="description-long"></slot>}
              </stzh-text>
            </stzh-popover>
          </div>
        }

        <div class={`${classPrefix}__description-text`}>
          {description ? description : <slot name="description"></slot>}
        </div>
      </div>
    </div>
  );
};
